interface DividerProps {
    margin?: string;
    maxWidth?: string;
}

const Divider = ({ margin, maxWidth }: DividerProps) => (
    <div
        style={
            {
                '--max-width': maxWidth,
            } as React.CSSProperties
        }
        className={`mx-auto w-full ${
            maxWidth ? 'max-w-[var(--max-width)]' : 'max-w-content'
        } ${margin || ''}`}
    >
        <hr className="divider-horizontal" />
    </div>
);

export default Divider;
